import fullFunctionality from './fullFunctionalityConfig'

export default {
    ...fullFunctionality,
    loadsMiniSiteManager: false,
    showMobileView: true
}
